/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {
    constructor() {
        this.container = document.getElementById("Facet-Drawer");
        let button = document.getElementById("Facets-Toggle");

        // Add functionality to buttons
        if (button) {
            button.addEventListener("click", (e) => {
                e.preventDefault();
                document
                    .getElementsByTagName("body")[0]
                    .classList.toggle("open-cc");
                this.container.classList.toggle("active");
            });
        }
    }
}

class CustomFacet extends HTMLElement {
    constructor() {
        super();
        window.scrollBy(0, 1);
        this.form = this.closest("form");
        this.input = this.querySelector("input");
        this.button = this.querySelector(".custom-facet--button");
        this.panel = this.querySelector(".custom-facet--list");
        this.group = this.dataset.group ?? "no-group";

        this.count = this.button.querySelector(".custom-facet--count");

        this.isSlider = this.dataset.slider === "true";

        this.ignoreSize = this.form.dataset.ignores === "true";

        this.button.addEventListener("click", this.togglePanel.bind(this));
        this.button.addEventListener("focusout", this.outFocus.bind(this));

        this.panel
            .querySelectorAll(".custom-facet--option")
            .forEach((option) => {
                option.addEventListener("click", this.onOptionClick.bind(this));
            });

        this.panel.querySelectorAll(".custom-facet--item").forEach((option) => {
            option.addEventListener("click", this.onButtonClick.bind(this));
        });

        if (this.isSlider) {
            let inputs = this.panel.querySelectorAll(".field__input");
            inputs.forEach((input) => {
                input.addEventListener("focusout", (e) => {
                    this.button.focus();
                });
            });
        }
    }

    togglePanel(e) {
        e.preventDefault();
        if (this.classList.contains("custom-facet--active")) {
            this.closePanel();
        } else {
            this.openPanel();
        }
    }

    openPanel() {
        // Close all other panels in the group

        document
            .querySelectorAll(`custom-facet[data-group="${this.group}"]`)
            .forEach((facet) => {
                facet.closePanel();
            });

        // Calculate the panel offset from left on desktop
        if (window.innerWidth > 768 || this.ignoreSize) {
            const buttonRect = this.button.getBoundingClientRect().x;
            const formRect = this.form.getBoundingClientRect().x;

            let dist = buttonRect - formRect;

            // Prevent the panel to go off screen
            if (dist + this.panel.offsetWidth > window.innerWidth - 20) {
                this.panel.style.right = "0";
                this.panel.style.left = "auto";
            } else {
                this.panel.style.left = `${buttonRect - formRect}px`;
                this.panel.style.right = "auto";
            }

            this.button.setAttribute("aria-expanded", "true");
            this.classList.add("custom-facet--active");
        } else {
            let drawer = document.getElementById("Facet-Drawer");
            document.getElementsByTagName("body")[0].classList.add("open-cc");

            let items = drawer.querySelectorAll("collapsible-row");
            let scroll_container = drawer.querySelector(
                ".side-panel-down-content"
            );

            items.forEach((item) => {
                item.children[0].removeAttribute("open");
                if (item.dataset.index === this.dataset.index) {
                    item.children[0].setAttribute("open", "true");

                    // Scroll to this element
                    if (scroll_container) {
                        scroll_container.scrollTop = item.offsetTop - 80;
                    }
                }
            });

            drawer.classList.add("active");
        }
    }

    outFocus(e) {
        if (window.innerWidth <= 768) return;
        if (
            !this.contains(e.relatedTarget) &&
            !e.relatedTarget?.classList.contains("facets__form")
        ) {
            this.closePanel();
        } else if (!this.isSlider) {
            this.button.focus();
        }
    }

    closePanel() {
        if (window.innerWidth > 768 || this.ignoreSize) {
            this.button.setAttribute("aria-expanded", "false");
            this.classList.remove("custom-facet--active");

            this.panel.style.left = "0";
            this.panel.style.right = "auto";
        } else {
            document
                .getElementsByTagName("body")[0]
                .classList.remove("open-cc");
            document.getElementById("Facet-Drawer").classList.remove("active");
        }
    }

    onOptionClick(e) {
        e.stopPropagation();
        // Update dropdown count
        let inp = e.currentTarget.querySelector("input");

        if (inp.tagName !== "INPUT" || inp.tagName !== "LABEL") return;

        if (inp.checked) {
            this.count.innerHTML = parseInt(this.count.innerHTML) + 1;
        } else {
            this.count.innerHTML = parseInt(this.count.innerHTML) - 1;
        }
        if (this.count.innerHTML === "0") {
            this.count.classList.add("hidden");
        } else {
            this.count.classList.remove("hidden");
        }

        this.input.value = e.currentTarget.dataset.value;
        this.input.dispatchEvent(new Event("change"));
    }

    onButtonClick(e) {
        this.input.value = e.currentTarget.dataset.value;
        this.form.dispatchEvent(new Event("change"));
    }
}

customElements.define("custom-facet", CustomFacet);

class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 500);

        this.querySelector("form").addEventListener(
            "input",
            this.debouncedOnSubmit.bind(this)
        );

        if (!document.getElementById("facet-dynamic-collection")) return;
    }

    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state
                ? event.state.searchParams
                : FacetFiltersForm.searchParamsInitial;

            if (searchParams === FacetFiltersForm.searchParamsPrev) return;

            FacetFiltersForm.renderPage(searchParams, null, true);
        };
        window.addEventListener("popstate", onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll(".js-facet-remove").forEach((element) => {
            element.classList.toggle("disabled", disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        const container = document.getElementsByClassName("thb-filter-count");
        document
            .getElementById("ProductGridContainer")
            .querySelector(".collection")
            .classList.add("loading");

        for (var item of container) {
            item.classList.add("loading");
        }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = (element) => element.url === url;

            if (FacetFiltersForm.filterData.some(filterDataUrl)) {
                FacetFiltersForm.renderSectionFromCache(
                    filterDataUrl,
                    event,
                    searchParams
                );
            } else {
                FacetFiltersForm.renderSectionFromFetch(
                    url,
                    event,
                    searchParams
                );
            }
        });
        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event, searchParams) {
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                FacetFiltersForm.filterData = [
                    ...FacetFiltersForm.filterData,
                    {
                        html,
                        url,
                    },
                ];

                FacetFiltersForm.renderFilters(html, event);
                FacetFiltersForm.renderProductGridContainer(html);
                FacetFiltersForm.renderProductCount(html);

                new FacetsToggle();
            });
    }

    static renderSectionFromCache(filterDataUrl, event, searchParams) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
    }

    static renderProductGridContainer(html) {
        let newC = new DOMParser().parseFromString(html, "text/html");

        const facets = newC.querySelectorAll("#FacetFiltersForm custom-facet");
        let id = "";
        let st = 0;
        facets.forEach((facet) => {
            let item = document.querySelector(
                `custom-facet[data-index="${facet.dataset.index}"]`
            );
            if (item && item.classList.contains("custom-facet--active")) {
                id = facet.dataset.index;
                st = item.panel.querySelector("ul")?.scrollTop;
            }
        });

        document.getElementById("ProductGridContainer").innerHTML =
            newC.getElementById("ProductGridContainer").innerHTML;

        if (id !== "") {
            let f = document.querySelector(`custom-facet[data-index="${id}"]`);
            let list = f.panel.querySelector("ul");
            if (list) list.scrollTop = st;
            f.button.click();
            f.button.focus();
        }
    }

    static renderProductCount(html) {
        const parsed = new DOMParser().parseFromString(html, "text/html");

        const countHtml = parsed.getElementById("ProductCount");
        const countHtmlMobile = parsed.getElementById("ProductCount-sm");

        if (countHtml) {
            const g = document.getElementById("ProductCount");
            g.innerHTML = countHtml.innerHTML;
            g.classList.remove("loading");
        }

        if (countHtmlMobile) {
            const g = document.getElementById("ProductCount-sm");
            g.innerHTML = countHtmlMobile.innerHTML;
            g.classList.remove("loading");
        }
    }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");

        const facetDetailsElements = parsedHTML.querySelectorAll(
            "#FacetFiltersFormMobile collapsible-row"
        );
        const matchesIndex = (element) => {
            const jsFilter = event
                ? event.target.closest("collapsible-row")
                : undefined;
            return jsFilter
                ? element.dataset.index === jsFilter.dataset.index
                : false;
        };
        const facetsToRender = Array.from(facetDetailsElements).filter(
            (element) => !matchesIndex(element)
        );
        const countsToRender =
            Array.from(facetDetailsElements).find(matchesIndex);

        facetsToRender.forEach((element) => {
            let item = document.querySelector(
                `collapsible-row[data-index="${element.dataset.index}"]`
            );
            if (item.children[0].getAttribute("open")) {
                element.children[0].setAttribute("open", "true");
            }
            item.innerHTML = element.innerHTML;
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender)
            FacetFiltersForm.renderCounts(
                countsToRender,
                event.target.closest("collapsible-row")
            );

      window.scrollBy(0, 1);
    }

    static renderActiveFacets(html) {
        const activeFacetElementSelectors = [".active-facets"];

        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML =
                activeFacetsElement.innerHTML;
        });

        FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
        const mobileElementSelectors = [".mobile-filter-count"];

        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML =
                html.querySelector(selector).innerHTML;
        });
    }

    static renderCounts(source, target) {
        const targetElement = target.querySelector(".facets__selected");
        const sourceElement = source.querySelector(".facets__selected");

        if (sourceElement && targetElement) {
            target.querySelector(".facets__selected").outerHTML =
                source.querySelector(".facets__selected").outerHTML;
        }
    }

    static updateURLHash(searchParams) {
        history.pushState(
            {
                searchParams,
            },
            "",
            `${window.location.pathname}${
                searchParams && "?".concat(searchParams)
            }`
        );
    }

    static getSections() {
        return [
            {
                section: document.getElementById("product-grid").dataset.id,
            },
        ];
    }

    static getFilterCount(name, html) {
        let f;
        if (html) {
            const parsedHTML = new DOMParser().parseFromString(
                html,
                "text/html"
            );
            f = parsedHTML.querySelector(`input[value^="${name}"]`);
        } else {
            f = document.querySelector(`input[value^="${name}"]`);
        }
        if (!f) return false;
        if (f.disabled) {
            return false;
        }
        return true;
    }

    onSubmitHandler(event) {
        event.preventDefault();
        const formData = new FormData(event.target.closest("form"));
        // get current url search params
        const urlSearchParams = new URLSearchParams(window.location.search);
      
        const searchParams = new URLSearchParams(formData);
        if (searchParams.get("filter.v.price.gte") === "0.00") {
            searchParams.delete("filter.v.price.gte");
        }
        if (document.querySelector(".price_slider")) {
            if (
                searchParams.get("filter.v.price.lte") ===
                parseFloat(
                    document.querySelector(".price_slider").dataset.max
                ).toFixed(2)
            ) {
                searchParams.delete("filter.v.price.lte");
            }
        }

        if (
            searchParams.get("sort_by") != null &&
            searchParams.size == 1 &&
            urlSearchParams.size > 1
        ) {
            urlSearchParams.set("sort_by", searchParams.get("sort_by"));
            FacetFiltersForm.renderPage(urlSearchParams.toString(), event);
            return;
        }
      
        FacetFiltersForm.renderPage(searchParams.toString(), event);
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url =
            event.currentTarget.href.indexOf("?") == -1
                ? ""
                : event.currentTarget.href.slice(
                      event.currentTarget.href.indexOf("?") + 1
                  );
        FacetFiltersForm.renderPage(url);
    }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll("a").forEach((item) => {
            item.addEventListener("click", (event) => {
                event.preventDefault();
                const form =
                    this.closest("facet-filters-form") ||
                    document.querySelector("facet-filters-form");
                form.onActiveFilterClick(event);
            });
        });
    }
}

customElements.define("facet-remove", FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        let slider = this.querySelector(".price_slider"),
            amounts = this.querySelector(".price_slider_amount"),
            args = {
                start: [
                    parseFloat(slider.dataset.minValue || 0),
                    parseFloat(slider.dataset.maxValue || slider.dataset.max),
                ],
                connect: true,
                step: 10,
                range: {
                    min: 0,
                    max: parseFloat(slider.dataset.max),
                },
            },
            event = new CustomEvent("input"),
            form =
                this.closest("facet-filters-form") ||
                document.querySelector("facet-filters-form");

        if (slider.classList.contains("noUi-target")) {
            slider.noUiSlider.destroy();
        }
        noUiSlider.create(slider, args);

        slider.noUiSlider.on("update", function (values) {
            amounts.querySelector(".field__input_min").value = values[0];
            amounts.querySelector(".field__input_max").value = values[1];
        });
        slider.noUiSlider.on("change", function (values) {
            form.querySelector("form").dispatchEvent(event);
        });
    }
}
customElements.define("price-slider", PriceSlider);

window.addEventListener("load", () => {
    new FacetsToggle();
});
